<template>
	<view>
		<view class="d-s-c record-item" v-for="(item,index) in recordData" :key="index">
			<text class="key-name gray6 p-10-0">{{item.name}}：</text>
			<text class="flex-1" v-if="item.type!='image'">{{item.value}}</text>
			<text class="flex-1" v-if="item.type=='image'">
				<image @click="preview(item.value,0)" :src="item.value" mode="aspectFill" v-if="item.value"></image>
			</text>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				recordData: {},
				tableM: {}
			}
		},
		props: ['table_record_id'],
		mounted() {
			this.getData();
		},
		methods: {
			getData() {
				let self = this;
				this._get('plus.table.table/detail', {
					table_record_id: self.table_record_id
				}, function(res) {
					self.recordData = res.data.detail.content;
					self.tableM = res.data.detail.tableM;
				})
			},
			//打开图片预览
			preview(e, index) {
				let self = this;
				let image_path_arr = [];
				let image_path_list = e;
				image_path_arr.push(image_path_list)
				let picnum = index * 1;
				uni.previewImage({
					urls: image_path_arr,
					current: picnum,
					indicator: 'default',
				});
			},
		}
	}
</script>

<style>
	.record-item image {
		width: 120rpx;
		height: 120rpx;
	}
</style>
